import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Auth } from 'src/app/models/auth';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { CollaboratorFiltered } from 'src/app/models/collaborator';
import { ExtractRequest } from 'src/app/models/request/extract-request';
import { Extract } from 'src/app/models/response/extract-response';
import { ParametersList, ParametersResponse } from 'src/app/models/response/parameters-response';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { ExtractService } from 'src/app/services/extract.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { environment } from 'src/environments/environment';
import {saveAs} from 'file-saver';
import { Product } from 'src/app/models/contract-assignor';

@Component({
  selector: 'app-extrato-list',
  templateUrl: './extrato-list.component.html',
  styleUrls: ['./extrato-list.component.css']
})
export class ExtratoListComponent implements OnInit {

    public currentUser: Auth;

    extractDetails: any;
    extractList = [];
    assignorContractList: CedenteContrato[];
    productList: Product[];
    parametersResponse: ParametersResponse;
    parametersList: ParametersList[];

    //#region filter form
    public startDateCtrl: FormControl = new FormControl();
    public endDateCtrl: FormControl = new FormControl();
    public datePeriodCtrl: FormControl = new FormControl();
    public productsCtrl: FormControl = new FormControl();
    public statusCtrl: FormControl = new FormControl();

    public collaboratorsServerSideCtrl: FormControl = new FormControl();
    public collaboratorsServerSideFilteringCtrl: FormControl = new FormControl();
    public searching = false;
    public collaboratorsFiltered: any;
    protected _onDestroy = new Subject<void>();
    //#endregion

    //#region filter
    public exibirFiltro = true;
    public filtroOn: boolean = false;
    public filtroPeriodo = 0;
    public filtroDataInicio = null
    public filtroDataFim = null
    public filtroColaborador: number[] =[];
    public filtroProduto: number[] = [];
    public filtroSituacao: string = null;
    //#endregion

    //#region pagination
    sortOrder: boolean = false;
    currentPage = 1;
    showItem = '10';
    totalItems = 0;
    collumnName = "name";
    //#endregion

    //#region parameters
    private parametros: { [key: string]: string };
    public labelRegister = 'Matrícula';
    public labelStatus = 'Situação';

    public showColumnRegister = true;
    public showColumnStatus = true;
    //#endregion

    constructor(
        private authenticationService: AuthenticationService,
        private parametersService: ParametrosDataService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private extractService: ExtractService,
        private contractService: ContratoService,
        private collaboratorsService: ColaboradorService,
        public datepipe: DatePipe) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.getParameters();
        this.getContracts();
        this.getExtract(1);
        this.collaboratorsFiltered = this.collaboratorsServerSideFilteringCtrl.valueChanges
        .pipe(
            map(search => search.trim()),
            filter(search => search.length > 2 || !!search ),
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(search => {
                return this.collaboratorsService.getCollaboratorFilter(this.currentUser.token.assignorGuid, search)
            }),
            map((res: any) => {
                this.searching = false;
                return res.result;
            }),
            delay(500),
            takeUntil(this._onDestroy)
        );
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    //#region Parameters
    loadViewConfig() {
        this.parametros = this.parametersService.currentParametrosValue;
        if (this.parametros) {

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelRegister = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelRegister = 'Matrícula';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaStatusColaborador
                ]
            ) {
                this.labelStatus = this.parametros[
                    ParametrosKey.labelPersonalizadaStatusColaborador
                ];
            } else {
                this.labelStatus = 'Situação';
            }

            if (this.parametros[ParametrosKey.exibirStatusColaborador] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirStatusColaborador]
                )) {
                this.showColumnStatus = false;
            }

            if (this.parametros[ParametrosKey.exibirMatriculaColaborador] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirMatriculaColaborador]
                )) {
                this.showColumnRegister = false;
            }
        }
    }
    //#endregion


    //#region Api calls
    getParameters(){
        this.parametersService.getParameters()
            .subscribe(response => {
                if(response.status == ApiError.Sucesso){
                    this.parametersResponse = response.result;
                    if(this.parametersResponse[0].parametroCodigo == 3){
                        this.parametersList = this.parametersResponse[0].parametros.filter(x=>x.dataPassada == true);
                    }
                }
            }
        );
    }

    getExtract(event){
        this.currentPage = event;
        const offset = this.currentPage - 1;

        const filterObject = new ExtractRequest();

        filterObject.assignorGuid = this.currentUser.token.assignorGuid;
        filterObject.limit = parseInt(this.showItem);
        filterObject.offset = offset;
        filterObject.startDate = this.filtroDataInicio;
        filterObject.endDate = this.filtroDataFim;
        filterObject.datePeriod = this.filtroPeriodo;
        filterObject.details = true;
        filterObject.products = this.filtroProduto;
        filterObject.collaborators = this.filtroColaborador;
        filterObject.status = this.filtroSituacao;

        this.alertService.clear();
        this.extractService
            .getExtract(
                filterObject
            )
            .subscribe(
                response => {

                    if (response.status === ApiError.Sucesso) {
                        this.extractDetails = response.result.details;
                        this.extractList = response.result.extract;
                        this.totalItems = this.extractDetails.totalItems;

                        for (const s of this.extractList) {
                            if(s.collaboratorDocument != null){
                                const tam = environment.TOTAL_CARACTERE_CPF - s.collaboratorDocument.toString().length;
                                let str = s.collaboratorDocument.toString();

                                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }

                                s.collaboratorDocument = str;
                            }
                        }
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao paginar o extrato'
                    );
                }
            );
    }

    getContracts(){
        this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.productList = response.result;
                    if (response.result.length <= 0 && response.result.length <= 0) {
                        this.alertService.error(response.message);
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar o filtro de produtos' + error);
            }
        );
    }

    getCollaborators(q: string = null): CollaboratorFiltered[]{
        this.collaboratorsService.getCollaboratorFilter(this.currentUser.token.assignorGuid, q)
        .subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.collaboratorsFiltered = response.result;
                    return this.collaboratorsFiltered;
                }
            },
            error => {
                this.alertService.error('Erro ao carregar o filtro de favorecidos' + error);
            }
        )
        return;
    }

    //#endregion

    //#region List Visualization

    orderBy(collumnName: string, sortOrder: boolean) {
        this.collumnName=collumnName;
        this.sortOrder=sortOrder;

        this.getExtract(1);
    }

    showItemChanged(event) {
        this.showItem = event;
        this.getExtract(1);
    }

    //#endregion

    //#region Filter

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg'}).result.then(()=>{},(e)=>{
            if(e == 0){
                this.deleteFilter();
            }
        });
    }

    applyFilter() {

        let start = this.startDateCtrl.value ;
        this.filtroDataInicio = start != null ? new Date(start.getFullYear()+"/"+(start.getMonth()+1)+"/"+start.getDate()+" 00:00:00 -00:00") : null;
        let end = this.endDateCtrl.value;
        this.filtroDataFim = end != null ?new Date(end.getFullYear()+"/"+(end.getMonth()+1)+"/"+end.getDate()+" 23:59:59 -00:00") : null;
        this.filtroPeriodo = this.datePeriodCtrl.value;
        this.filtroProduto = this.productsCtrl.value;
        this.filtroColaborador = this.collaboratorsServerSideCtrl.value;
        this.filtroSituacao = this.statusCtrl.value;

        if(
            (this.filtroDataInicio == null ||
            this.filtroDataFim == null) &&
            this.filtroPeriodo == null
        ){
            if(this.filtroDataInicio != null && this.filtroPeriodo == null){
                this.endDateCtrl.setErrors({'required': true});
                this.endDateCtrl.markAsTouched();
            } else if (this.filtroDataInicio != null && this.filtroPeriodo != null){
                this.endDateCtrl.setErrors({'required': true});
            }

            if(this.filtroDataFim != null && this.filtroPeriodo == null){
                this.startDateCtrl.setErrors({'required': true});
                this.startDateCtrl.markAsTouched();
            } else if (this.filtroDataFim != null && this.filtroPeriodo != null){
                this.endDateCtrl.setErrors({'required': true});
            }
            if((this.filtroDataInicio == null && this.filtroDataFim == null) || this.filtroPeriodo == null){
                this.startDateCtrl.setErrors({'required': true});
                this.startDateCtrl.markAsTouched();
                this.endDateCtrl.setErrors({'required': true});
                this.endDateCtrl.markAsTouched();
            }
            this.filtroOn = false;

        } else {
            this.filtroOn = true;
            this.getExtract(1);
            this.modalService.dismissAll();
        }

    }

    deleteFilter(){
        this.filtroDataInicio = null
        this.filtroDataFim = null
        this.filtroPeriodo = 0
        this.filtroProduto = []
        this.filtroColaborador = []
        this.filtroSituacao = null
        this.filtroOn = false;

        this.startDateCtrl.setValue(null);
        this.endDateCtrl.setValue(null);
        this.datePeriodCtrl.setValue(null);;
        this.productsCtrl.setValue(null);;
        this.collaboratorsServerSideCtrl.setValue(null);
        this.statusCtrl.setValue(null);

        this.getExtract(1);
    }

    exportExtractExcel(){
        var result = [];
        let date: any = new Date();
        date = date.toLocaleDateString('pt-BR');
        date = date.split('/');

        const excelService = new ExcelService();
        const worksheets = new Array<WorksheetData>();
        const ws = new WorksheetData();
        ws.worksheetTitle = 'Extrato_' + date[2] + '-' + date[1] + '-' + date[0];
        ws.worksheetHeaders = ['Recarga','Data da recarga','Gestor','Nome','CPF','Matrícula','Produto','Valor','Data de processamento','Situação'];
        ws.WorksheetRows = [];

        const filterObject = new ExtractRequest();

        filterObject.assignorGuid = this.currentUser.token.assignorGuid;
        filterObject.limit = this.extractDetails.totalItems;
        filterObject.offset = 0;
        filterObject.startDate = this.filtroDataInicio;
        filterObject.endDate = this.filtroDataFim;
        filterObject.datePeriod = this.filtroPeriodo;
        filterObject.details = true;
        filterObject.products = this.filtroProduto;
        filterObject.collaborators = this.filtroColaborador;
        filterObject.status = this.filtroSituacao;

        this.extractService
        .getExtract(
            filterObject
        )
        .subscribe(
            response => {

                if (response.status === ApiError.Sucesso) {
                    result = response.result.extract;

                    for (const s of result) {;
                        const tam = environment.TOTAL_CARACTERE_CPF - s.collaboratorDocument.toString().length;
                        let str = s.collaboratorDocument.toString();

                        for (let i = 0; i < tam; i++) { str = '0' + str; }

                        s.collaboratorDocument = str;
                    }

                    result.forEach((r) => {
                        const lr = new Array<string>();
                        lr.push(r.purchaseId);
                        lr.push(this.datepipe.transform(r.purchaseDate, 'dd/MM/yyyy HH:mm'));
                        lr.push(r.managerName);
                        lr.push(r.collaboratorName);
                        lr.push(this.formatarCpf(r.collaboratorDocument));
                        lr.push(r.productName );
                        lr.push(r.collaboratorRegister);
                        lr.push(r.orderItemValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                        lr.push(this.datepipe.transform(r.releaseDate, 'dd/MM/yyyy HH:mm'));
                        lr.push(r.statusDescription);
                        ws.WorksheetRows.push(lr);
                    });

                    worksheets.push(ws);

                    /*excelService.generateExcel('Extrato Portal Cedente', worksheets).csv
                    .writeBuffer({ encoding: 'UTF-8', formatterOptions: { delimiter: ';' } }).then((data) => {
                        const blob = new Blob(['\ufeff', data], { type: 'text/csv; charset=UTF-8,'  });
                        saveAs(blob, ws.worksheetTitle + '.csv');
                    });*/

                    excelService.generateExcel('Extrato Portal Cedente', worksheets).xlsx
                    .writeBuffer().then((data) => {
                        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, ws.worksheetTitle + '.xlsx');
                    });

                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(
                    'Ocorreu um erro ao paginar o extrato'
                );
            }
        );
    }

    formatarCpf(cpf){
        return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
    }
    //#endregion
}
